/*const (
    StatusUnknown  = iota // 0
    StatusOK              // 1
    StatusLow            // 2
    StatusLowLow         // 3
    StatusStarting       // 4
    StatusPaused         // 5
    StatusStopped        // 6
    StatusFail           // 7 (объединен со смысловым дубликатом по коду StatusFault)
    StatusOffline        // 8
    StatusWarning        // 9
    StatusPending        // 10
    StatusStopping       // 11
)*/

export enum MINER_STATUSES_E {
  UNKNOWN = 0,
  OK = 1,
  LOW = 2,
  BAD = 3,
  STARTING = 4,
  PAUSED = 5,
  STOPPED = 6,
  FAIL = 7,
  OFF = 8,
  WARNING = 9,
  PENDING = 10,
  STOPPING = 11,
}

export enum MinerFilterableStatus {
  UNKNOWN = MINER_STATUSES_E.UNKNOWN,
  OK = MINER_STATUSES_E.OK,
  LOW = MINER_STATUSES_E.LOW,
  BAD = MINER_STATUSES_E.BAD,
  PAUSED = MINER_STATUSES_E.PAUSED,
  STOPPED = MINER_STATUSES_E.STOPPED,
  //CONNECTION_ERROR = MINER_STATUSES_E.CONNECTION_ERROR,
  FAIL = MINER_STATUSES_E.FAIL,
  OFF = MINER_STATUSES_E.OFF,
  STOPPING = MINER_STATUSES_E.STOPPING,
  STARTING = MINER_STATUSES_E.STARTING,
  WARNING = MINER_STATUSES_E.WARNING,
  PENDING = MINER_STATUSES_E.PENDING,
}

/*
      MinerStatuses.STOPED,
      MinerStatuses.PAUSED,
      MinerStatuses.CONNECTION_ERROR,
      MinerStatuses.STARTING,
*/
